export const GiraffePeeper = () => (
  <svg
    width="264"
    height="264"
    viewBox="0 0 264 264"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="peeper-mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="264"
      height="264"
    >
      <path d="M0 0H264V264L0 0Z" fill="#C7B4FD" />
    </mask>
    <g mask="url(#peeper-mask0)">
      <path d="M0 0h256a8 8 0 018 8v256" fill="#C7B4FD" />
      <path
        d="M177.918 94.4156C177.918 94.4156 196.608 234.598 183.289 251.977C168.722 270.986 122.681 258.775 122.681 258.775L118.368 279.298C118.368 279.298 159.665 292.498 192.951 283.259L195.544 319.613C195.544 319.613 150.244 355.689 149.957 421.248L167.799 424.14C167.799 424.14 179.568 348.242 234.56 342.534L256.172 340.358C256.172 340.358 267.965 334.415 267.237 315.568C267.274 299.111 228.374 219.782 228.374 219.782C222.937 208.723 203.987 64.5808 203.987 64.5808L174.036 69.1704L177.918 94.4156Z"
        fill="#FFDD06"
      />
      <path
        d="M190.352 20.0348C189.985 18.9336 189.093 18.0515 187.993 17.6859L186.606 17.2115C185.506 16.8458 184.268 16.9469 183.248 17.5737C182.228 18.2005 181.635 19.2038 181.497 20.405L181.31 22.2713C181.271 22.5096 181.231 22.7479 181.073 22.9665L180.737 23.5228C180.232 24.3573 179.856 25.1519 179.52 26.0755L177.732 32.4503L172.885 28.1596L172.836 28.0902C172.142 27.4857 171.299 27.0403 170.398 26.585L169.833 26.3079C169.664 26.2189 169.387 26.0505 169.248 25.7827L168.138 24.3749C167.374 23.4529 166.304 22.9086 165.145 22.9004C163.986 22.8921 162.847 23.4992 162.155 24.3638L161.294 25.5065C160.591 26.4306 160.334 27.6121 160.632 28.7631C160.93 29.914 161.634 30.8261 162.715 31.3109L164.419 32.0826C164.647 32.1816 164.875 32.2805 165.014 32.5483L165.42 33.044C166.035 33.7577 166.719 34.4217 167.472 35.036L172.616 38.2742C174.598 39.5815 176.036 41.5943 176.949 44.5607C177.237 45.404 177.714 47.319 177.714 47.319L179.244 52.8354L187.196 50.5409L185.409 45.1043C185.409 45.1043 184.922 43.2489 184.644 42.346C183.859 39.3397 183.956 36.9078 184.985 34.7524L187.527 29.3591L187.546 29.24C187.823 28.3066 188.03 27.4229 188.188 26.4698L188.326 25.6358C188.365 25.3976 188.464 25.1691 188.623 24.9505L189.612 23.4007C190.641 22.3471 190.72 21.136 190.352 20.0348Z"
        fill="#724010"
      />
      <path
        d="M211.252 31.389C207.171 32.0599 203.012 33.5747 200.241 36.6656C197.984 39.2297 196.025 42.2103 195.226 45.5663C194.199 49.5579 193.399 53.6484 192.83 60.0414C192.83 60.0414 197.615 61.7515 197.349 62.9926C202.658 62.2802 210.948 61.6328 214.799 58.2922C218.858 54.8024 220.489 51.2169 221.614 45.8951C222.839 40.7121 222.23 35.1646 222.989 29.8433C219.136 30.246 214.758 30.8677 211.252 31.389Z"
        fill="#FFDD06"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M188.866 44.513C191.52 43.6059 194.383 43.6513 196.999 44.8187C197.226 44.9177 197.454 45.0166 197.623 45.1057C200.338 46.7791 202.321 48.8209 202.769 52.3836L207.924 96.1382L178.269 99.6752L168.365 100.851C168.305 100.841 167.929 100.901 167.869 100.891C157.41 102.098 147.292 96.4449 142.887 86.9029C142.837 86.8335 142.847 86.7739 142.797 86.7045C142.807 86.6449 142.748 86.6351 142.758 86.5755C138.718 76.2984 146.912 66.2715 155.823 60.4024C159.971 57.4782 171.566 51.6251 179.399 47.8419C179.854 47.6725 180.201 47.4239 180.706 47.3239L188.866 44.513Z"
        fill="#FFDD06"
      />
      <path
        d="M176.261 64.9486C177.36 64.2126 178.637 63.8732 179.856 64.2586C180.966 64.5646 181.828 65.2582 182.413 66.1506C182.998 67.043 184.434 66.8524 184.552 65.7703L184.562 65.7108C184.739 63.5368 183.499 61.4345 181.586 60.4447C178.326 58.7423 174.563 60.445 173.516 63.8211C173.378 64.2878 173.299 64.7644 173.279 65.2507C173.221 66.3426 174.529 66.9263 175.281 66.0716C175.498 65.4956 175.845 65.247 176.261 64.9486Z"
        fill="#373A3B"
      />
      <path
        d="M178.655 99.5562C178.655 99.5562 191.274 98.585 198.452 93.2248C198.452 93.2248 194.737 105.706 179.672 107.803C179.622 107.733 178.655 99.5562 178.655 99.5562Z"
        fill="#E5C504"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M120.399 278.471L124.644 260.569C124.911 259.328 124.266 258.058 123.008 257.544L111.712 253.471C110.107 252.838 108.315 254.072 108.336 255.789L107.462 278.411C107.394 279.929 108.722 281.128 110.257 281.077L118.171 280.489C119.182 280.289 120.162 279.534 120.399 278.471Z"
        fill="#C7890D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M190.014 148.255C189.58 150.875 187.165 152.556 184.609 152.133C184.549 152.123 184.549 152.123 184.49 152.114C184.26 149.077 183.921 145.961 183.611 143.033C184.403 142.675 185.265 142.634 186.097 142.771C188.713 143.204 190.438 145.693 190.014 148.255Z"
        fill="#C7890D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.747 247.687L208.407 249.28C207.397 249.48 206.594 248.797 206.444 247.854L204.802 237.484C204.294 234.279 206.303 231.001 209.482 230.242C213.027 229.483 216.427 231.82 216.885 235.323C220.401 234.742 223.652 237.239 224.021 240.911C224.45 244.225 222.006 247.186 218.747 247.687Z"
        fill="#C7890D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M211.895 161.056C211.629 162.665 210.105 163.759 208.5 163.493C206.895 163.227 205.804 161.701 206.07 160.092C206.336 158.484 207.861 157.39 209.466 157.656C211.081 157.862 212.162 159.448 211.895 161.056Z"
        fill="#C7890D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M225.97 210.694C225.357 211.816 224.139 212.533 222.831 212.316C221.167 212.041 220.135 210.524 220.402 208.915C220.668 207.307 222.192 206.213 223.797 206.479C224.332 206.567 224.848 206.775 225.274 207.152C225.503 208.352 225.731 209.553 225.97 210.694Z"
        fill="#C7890D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M217.154 184.632C216.799 186.776 214.779 188.278 212.58 187.914C210.38 187.55 209.002 185.547 209.367 183.343C209.722 181.199 211.741 179.697 213.881 180.051C216.021 180.405 217.518 182.428 217.154 184.632Z"
        fill="#C7890D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M202.416 200.247C202.061 202.391 200.042 203.893 197.842 203.529C195.703 203.174 194.265 201.162 194.63 198.958C194.984 196.813 197.004 195.312 199.144 195.666C201.333 196.089 202.771 198.102 202.416 200.247Z"
        fill="#C7890D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M214.664 141.012C213.931 141.381 213 141.471 212.168 141.334C209.79 140.94 208.085 138.699 208.499 136.198C208.893 133.815 211.061 132.154 213.508 132.498C213.827 135.366 214.275 138.194 214.664 141.012Z"
        fill="#C7890D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M194.395 176.764C193.862 179.981 190.823 182.11 187.673 181.588C187.435 181.549 187.138 181.499 186.91 181.401C186.709 177.818 186.409 174.096 186.089 170.494C187.149 169.996 188.347 169.766 189.595 169.973C192.736 170.554 194.927 173.548 194.395 176.764Z"
        fill="#C7890D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M226.978 259.944C225.939 261.424 223.81 261.745 222.333 260.705C220.856 259.665 220.538 257.531 221.577 256.051C222.616 254.571 224.745 254.25 226.222 255.29C227.758 256.34 228.146 258.423 226.978 259.944Z"
        fill="#C7890D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M197.843 203.529C195.703 203.175 194.265 201.162 194.63 198.958C194.985 196.813 197.004 195.312 199.144 195.666C201.284 196.02 202.781 198.043 202.416 200.247C202.052 202.451 200.042 203.893 197.843 203.529ZM208.5 163.493C206.895 163.227 205.804 161.7 206.071 160.092C206.337 158.484 207.862 157.39 209.466 157.655C211.071 157.921 212.162 159.448 211.896 161.056C211.64 162.605 210.105 163.759 208.5 163.493ZM209.308 183.333C209.663 181.189 211.682 179.687 213.822 180.041C215.962 180.395 217.459 182.418 217.095 184.622C216.74 186.767 214.72 188.268 212.521 187.904C210.321 187.54 208.953 185.478 209.308 183.333ZM218.747 247.687L208.407 249.28C207.397 249.48 206.594 248.797 206.445 247.854L204.802 237.484C204.295 234.279 206.303 231.001 209.482 230.242C213.028 229.482 216.427 231.82 216.886 235.323C220.402 234.742 223.653 237.238 224.022 240.91C224.45 244.225 222.006 247.186 218.747 247.687ZM226.978 259.943C225.939 261.424 223.81 261.744 222.333 260.704C220.857 259.664 220.538 257.531 221.577 256.05C222.616 254.57 224.745 254.249 226.222 255.289C227.758 256.339 228.146 258.423 226.978 259.943ZM237.443 278.628C235.543 281.251 231.849 281.802 229.232 279.901C226.626 277.939 226.068 274.297 227.968 271.674C229.927 269.061 233.562 268.5 236.189 270.342C238.726 272.353 239.284 275.995 237.443 278.628ZM252.52 279.043C251.481 280.523 249.351 280.844 247.875 279.804C246.398 278.764 246.079 276.63 247.118 275.15C248.157 273.669 250.287 273.349 251.763 274.389C253.359 275.448 253.618 277.572 252.52 279.043Z"
        fill="#C7890D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M246.729 259.418C246.729 259.418 246.719 259.478 246.66 259.468C244.701 262.081 241.066 262.643 238.449 260.741C235.842 258.779 235.285 255.137 237.185 252.514C238.451 250.766 240.481 249.939 242.532 250.095C243.921 253.14 245.3 256.244 246.729 259.418Z"
        fill="#C7890D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M237.938 240.215C237.859 240.325 237.76 240.553 237.681 240.662C236.355 242.401 233.899 242.851 232.164 241.524C230.43 240.197 229.982 237.736 231.308 235.997C232.258 234.685 233.813 234.147 235.229 234.443C236.033 236.228 236.936 238.152 237.938 240.215Z"
        fill="#C7890D"
      />
      <path
        d="M171.853 51.3662C173.401 42.3815 180.362 38.3317 187.613 39.5321C193.676 40.5357 198.227 45.8788 200.035 53.0324L197.094 53.8307C197.094 53.8307 193.834 39.9498 183.068 41.5337C183.068 41.5337 176.174 41.8613 173.358 50.7586L171.853 51.3662Z"
        fill="#535252"
      />
      <path
        d="M190.352 20.0348C189.985 18.9336 189.093 18.0515 187.993 17.6859L186.606 17.2115C185.506 16.8458 184.268 16.9469 183.248 17.5737C182.228 18.2005 181.635 19.2038 181.497 20.405L181.31 22.2713C181.271 22.5096 181.231 22.7479 181.073 22.9665L180.737 23.5228C180.232 24.3573 179.856 25.1519 179.52 26.0755L177.732 32.4503L172.885 28.1596L172.836 28.0902C172.142 27.4857 171.299 27.0403 170.398 26.585L169.833 26.3079C169.664 26.2189 169.387 26.0505 169.248 25.7827L168.138 24.3749C167.374 23.4529 166.304 22.9086 165.145 22.9004C163.986 22.8921 162.847 23.4992 162.155 24.3638L161.294 25.5065C160.591 26.4306 160.334 27.6121 160.632 28.7631C160.93 29.914 161.634 30.8261 162.715 31.3109L164.419 32.0826C164.647 32.1816 164.875 32.2805 165.014 32.5483L165.42 33.044C166.035 33.7577 166.719 34.4217 167.472 35.036L172.616 38.2742C174.598 39.5815 176.036 41.5943 176.949 44.5607C177.237 45.404 177.714 47.319 177.714 47.319L178.052 48.5989L180.032 47.7027L185.736 45.7092L185.478 45.0545C185.478 45.0545 184.991 43.1991 184.713 42.2963C183.929 39.29 184.026 36.8581 185.054 34.7027L187.794 29.2198L187.814 29.1006C188.09 28.1672 188.298 27.2835 188.455 26.3304L188.564 25.6752C188.603 25.4369 188.702 25.2085 188.86 24.9899L189.85 23.4401C190.641 22.3471 190.72 21.136 190.352 20.0348Z"
        fill="#724010"
      />
      <path
        d="M201.107 68.6946C201.107 68.6946 198.783 85.6902 185.522 89.7988L185.016 88.0625C185.016 88.0625 196.583 84.9589 199.68 67.724L201.107 68.6946Z"
        fill="#535252"
      />
      <path
        d="M182.582 92.8008C184.979 92.3407 186.681 90.5417 186.353 88.8351C186.025 87.1284 183.815 86.0894 181.349 86.5992C178.952 87.0592 177.25 88.8582 177.578 90.5649C177.966 92.2814 180.185 93.2608 182.582 92.8008Z"
        fill="#535252"
      />
      <path
        d="M198.81 69.6599C203.03 70.3585 207.138 66.9382 207.956 61.9942C208.775 57.0501 205.988 52.4885 201.768 51.7899C197.547 51.0914 193.439 54.5117 192.621 59.4557C191.802 64.3997 194.53 68.9515 198.81 69.6599Z"
        fill="#535252"
      />
      <path
        d="M199.977 67.7726C202.712 68.2252 205.483 65.5016 206.104 61.7489C206.735 57.9366 204.979 54.5249 202.245 54.0723C199.511 53.6197 196.739 56.3433 196.118 60.096C195.487 63.9082 197.243 67.32 199.977 67.7726Z"
        fill="#848484"
      />
      <path
        d="M105.225 280.856L59.515 273.289L57.1113 225.828L102.168 233.286L105.225 280.856Z"
        fill="#C0C0BF"
      />
      <path
        d="M102.897 282L57.2465 274.444L54.8428 226.983L99.8396 234.431L102.897 282Z"
        fill="#999999"
      />
    </g>
  </svg>
);
